export default "__VITE_ASSET__Di20WWo8__"